import ramses from '../api/ramses'

async function createUser(data) {
  try {
    const response = await ramses.post(`/users/register`, data)
    return response
  } catch (error) {
    console.error('axios error response:', error.response)
    return error.response || error
  }
}

async function getUsers() {
  try {
    const response = await ramses.get(`/users/register`)
    return response
  } catch (error) {
    console.error('axios error response:', error.response)
    return error.response || error
  }
}

async function updateUser(userId, data) {
  try {
    const response = await ramses.put(`/users/register/${userId}`, data)
    return response
  } catch (error) {
    console.error('axios error response:', error.response)
    return error.response || error
  }
}

async function deleteUser(userId) {
  try {
    const response = await ramses.delete(`/users/register/${userId}`)
    return response
  } catch (error) {
    console.error('axios error response:', error.response)
    return error.response || error
  }
}

export {
  createUser,
  getUsers,
  updateUser,
  deleteUser
}